const stagingGoogleMapsApiKey = 'AIzaSyBRR79it9lPoLWhrAjMCfmTL0baZ90v_CY';

const googleMapsApiKeyToBeUsed =
  process.env.NODE_ENV === 'development' && process.env.REACT_APP_GOOGLE_MAPS_KEY
    ? process.env.REACT_APP_GOOGLE_MAPS_KEY
    : stagingGoogleMapsApiKey;

const stagingEnvironment = {
  checkr: {
    baseUrl: ' https://dashboard.checkrhq-staging.net',
  },
  api: {
    baseUrl: 'https://api.hitch-dev.net',
  },
  pusher: {
    key: '465b70d7691cb62ad395',
  },
  googleapis: {
    apiKey: googleMapsApiKeyToBeUsed,
  },
  growthbook: {
    // "Admin Dashboard - Staging" SDK connection, tied to the GrowthBook
    // staging environment. Previously this pointed at sdk-z7y8rt9V7D9qd7UN,
    // which is the "Admin Dashboard" connection on the *production* env — so
    // the staging site was reading prod-env flag state (HITCH-5178).
    clientKey: 'sdk-iy6gIul5yxyXlzhi',
    apiHost: 'https://cdn.growthbook.io',
  },
};

export default stagingEnvironment;
